<template>
    <div class="ctw-text-white ctw-flex ctw-max-w-full" :class="{ 'ctw-justify-start': isBotMessage, 'ctw-justify-end': !isBotMessage }">
        <div v-if="props.isLoading" class="ctw-flex">
            <div class="ctw-mr-3 ctw-w-8 ctw-shrink-0 ctw-rounded-full">
                <message-avatar :avatarUrl="avatarUrl" />
            </div>
            <div class="ctw-flex ctw-items-center ctw-p-4 ctw-rounded-md ctw-border ctw-border-white6 ctw-bg-white6">
                <div class="dotsloader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div
            v-else
            class="ctw-flex"
            :class="{ 'ctw-w-full': isBotMessage}"
        >
            <div v-if="isBotMessage" class="ctw-mr-3 ctw-shrink-0">
                <message-avatar :avatarUrl="avatarUrl" />
            </div>
            <div 
                class="
                    ctw-flex-grow ctw-px-4 ctw-py-3 ctw-rounded-md
                    ctw-prose ctw-prose-sm ctw-text-white/80
                    ctw-border ctw-border-white6
                "
                :class="{
                    'ctw-bg-white6': isBotMessage,
                    'ctw-bg-white12': !isBotMessage,
                }
            ">
                <Markdown :source="text" />
            </div>
        </div>
    </div>
</template>

<script setup>
import Markdown from 'vue3-markdown-it';
import { defineProps } from 'vue';
import MessageAvatar from './MessageAvatar.vue';

const props = defineProps(['sender', 'text', 'isLoading', 'isBotMessage', 'avatarUrl']);

</script>